import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const STORAGE_KEY = 'mobile_app_banner_dismissed';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.reservours.restaurantmanager';
const APP_STORE_URL = 'https://apps.apple.com/hu/app/reservours-restaurant-manager/id6470688378';

function isMobilePhone(): boolean {
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth < 768;
    return isTouch && isSmallScreen;
}

function isIOS(): boolean {
    return /iPhone|iPad|iPod/.test(navigator.userAgent);
}

function isAndroid(): boolean {
    return /Android/.test(navigator.userAgent);
}

const MobileAppBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (isMobilePhone() && !localStorage.getItem(STORAGE_KEY)) {
            setVisible(true);
        }
    }, []);

    function handleDismiss() {
        localStorage.setItem(STORAGE_KEY, '1');
        setVisible(false);
    }

    if (!visible) return null;

    const showAndroid = isAndroid() || (!isIOS());
    const showIOS = isIOS() || (!isAndroid());

    return (
        <div className="fixed inset-0 z-[9999] flex items-end justify-center bg-black bg-opacity-50">
            <div className="w-full bg-white rounded-t-2xl p-6 shadow-2xl">
                {/* Close button */}
                <button
                    onClick={handleDismiss}
                    className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-gray-100 text-gray-500 transition-colors"
                    aria-label="Bezárás"
                >
                    <CloseIcon />
                </button>

                {/* Logo + title */}
                <div className="flex items-center gap-3 mb-3 pr-8">
                    <img
                        src="/logo192.png"
                        alt="ReservOurs"
                        className="w-12 h-12 rounded-xl shadow"
                        onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                    />
                    <div>
                        <p className="font-bold text-primary-dark text-base leading-tight">
                            ReservOurs Restaurant Manager
                        </p>
                        <p className="text-xs text-gray-500 mt-0.5">
                            Töltsd le az appot a legjobb élményért
                        </p>
                    </div>
                </div>

                {/* Store buttons */}
                <div className="flex flex-col gap-2 mt-4">
                    {showAndroid && (
                        <a
                            href={PLAY_STORE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center gap-2 bg-primary text-white rounded-xl py-3 font-semibold text-sm"
                        >
                            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white">
                                <path d="M3.18 23.76c.3.17.65.19.97.07l11.65-6.73-2.5-2.5-10.12 9.16zm-1.11-19.7a1.5 1.5 0 0 0-.07.5v14.88c0 .18.03.35.07.5l.07.07L13.5 8.65v-.22L2.14 4.0l-.07.06zm18.57 8.35-2.97-1.71-2.78 2.78 2.78 2.78 2.98-1.72c.85-.49.85-1.64 0-2.13zm-17.46 9.86 11.08-6.4-2.5-2.5L2.18 22.27l1 1.2-.02.01z"/>
                            </svg>
                            Google Play
                        </a>
                    )}
                    {showIOS && (
                        <a
                            href={APP_STORE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center gap-2 bg-primary text-white rounded-xl py-3 font-semibold text-sm"
                        >
                            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white">
                                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                            </svg>
                            App Store
                        </a>
                    )}
                </div>

                {/* Browser link */}
                <button
                    onClick={handleDismiss}
                    className="w-full text-center text-xs text-gray-400 mt-3 py-1"
                >
                    Folytatás böngészőben
                </button>
            </div>
        </div>
    );
};

export default MobileAppBanner;
